import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Render error caught by ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="flex flex-col items-center justify-center text-center py-12 px-6" data-testid="error-boundary-fallback">
            <AlertTriangle className="w-8 h-8 text-amber-500 mb-3" />
            <p className="font-heading font-semibold">This content couldn't be displayed</p>
            <p className="text-sm text-muted-foreground mt-1 max-w-sm">
              Some of the underlying data looks incomplete. Please contact HR if this keeps happening.
            </p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
